import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, TextField, Checkbox, FormControlLabel, Table, TableBody, TableCell, TableHead, TableRow, TableContainer, Paper, Radio, RadioGroup, FormLabel, useMediaQuery, useTheme } from '@mui/material';
import axios from 'axios';

const API_URL = '/api/convidados';

function Convidados({ isAdmin = true }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [convidados, setConvidados] = useState([]);
  const [form, setForm] = useState({ nome: '', padrinho: false, noivo: 'Graziele', confirmado: false, presente: false });
  const [editId, setEditId] = useState(null);
  const [filtroNome, setFiltroNome] = useState('');
  const [filtroNoivo, setFiltroNoivo] = useState('Todos');
  const [filtroPadrinho, setFiltroPadrinho] = useState('Todos');
  const [filtroConfirmado, setFiltroConfirmado] = useState('Todos');

  const fetchConvidados = async () => {
    const res = await axios.get(API_URL);
    setConvidados(res.data);
  };

  useEffect(() => {
    fetchConvidados();
    const interval = window.setInterval(() => {
      fetchConvidados();
    }, 5000);
    return () => window.clearInterval(interval);
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (editId) {
      await axios.put(`${API_URL}/${editId}`, form);
    } else {
      await axios.post(API_URL, form);
    }
    setForm({ nome: '', padrinho: false, noivo: 'Graziele', confirmado: false, presente: false });
    setEditId(null);
    fetchConvidados();
  };

  const handleEdit = (c) => {
    setForm({ nome: c.nome, padrinho: !!c.padrinho, noivo: c.noivo || 'Graziele', confirmado: !!c.confirmado, presente: !!c.presente });
    setEditId(c.id);
  };

  const handleDelete = async (id) => {
    await axios.delete(`${API_URL}/${id}`);
    fetchConvidados();
  };

  const handleToggleConfirmado = async (convidado) => {
    const updatedConvidado = { ...convidado, confirmado: !convidado.confirmado };
    setConvidados(prev => prev.map(item => item.id === convidado.id ? { ...item, confirmado: !item.confirmado } : item));
    await axios.put(`${API_URL}/${convidado.id}`, updatedConvidado);
    fetchConvidados();
  };

  const handleTogglePresente = async (convidado) => {
    const updatedConvidado = { ...convidado, presente: !convidado.presente };
    setConvidados(prev => prev.map(item => item.id === convidado.id ? { ...item, presente: !item.presente } : item));
    await axios.put(`${API_URL}/${convidado.id}`, updatedConvidado);
    fetchConvidados();
  };

  // Filtro dos convidados
  const convidadosFiltrados = convidados.filter(c => {
    const nomeMatch = c.nome.toLowerCase().includes(filtroNome.toLowerCase());
    const noivoMatch = filtroNoivo === 'Todos' || (c.noivo && c.noivo.toLowerCase() === filtroNoivo.toLowerCase());
    const padrinhoMatch =
      filtroPadrinho === 'Todos' ||
      (filtroPadrinho === 'Sim' && c.padrinho) ||
      (filtroPadrinho === 'Não' && !c.padrinho);
    const confirmadoMatch =
      filtroConfirmado === 'Todos' ||
      (filtroConfirmado === 'Sim' && c.confirmado) ||
      (filtroConfirmado === 'Não' && !c.confirmado);
    return nomeMatch && noivoMatch && padrinhoMatch && confirmadoMatch;
  });

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Lista de Convidados</Typography>
      {isAdmin && (
        <Paper sx={{ p: 2, mb: 2 }}>
          <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
            <TextField label="Nome" name="nome" value={form.nome} onChange={handleChange} required sx={{ minWidth: { xs: '100%', sm: 220 } }} />
            <FormControlLabel control={<Checkbox name="padrinho" checked={form.padrinho} onChange={handleChange} />} label="Padrinho" />
            <FormControlLabel control={<Checkbox name="confirmado" checked={form.confirmado} onChange={handleChange} />} label="Confirmado" />
            <FormControlLabel control={<Checkbox name="presente" checked={form.presente} onChange={handleChange} />} label="Presente" />
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1 }}>
              <FormLabel sx={{ mr: 1 }}>Noivo responsável:</FormLabel>
              <RadioGroup row name="noivo" value={form.noivo} onChange={handleChange}>
                <FormControlLabel value="Graziele" control={<Radio />} label="Graziele" />
                <FormControlLabel value="Fernando" control={<Radio />} label="Fernando" />
              </RadioGroup>
            </Box>
            <Button type="submit" variant="contained" color="primary">{editId ? 'Salvar' : 'Adicionar'}</Button>
            {editId && <Button onClick={() => { setEditId(null); setForm({ nome: '', padrinho: false, noivo: 'Graziele', confirmado: false, presente: false }); }} sx={{ ml: 1 }}>Cancelar</Button>}
          </Box>
        </Paper>
      )}
      <Paper sx={{ p: 2, mb: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <TextField label="Buscar por nome" value={filtroNome} onChange={e => setFiltroNome(e.target.value)} sx={{ minWidth: { xs: '100%', sm: 220 } }} />
          <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1 }}>
            <FormLabel>Noivo:</FormLabel>
            <RadioGroup row value={filtroNoivo} onChange={e => setFiltroNoivo(e.target.value)}>
              <FormControlLabel value="Todos" control={<Radio />} label="Todos" />
              <FormControlLabel value="Graziele" control={<Radio />} label="Graziele" />
              <FormControlLabel value="Fernando" control={<Radio />} label="Fernando" />
            </RadioGroup>
          </Box>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1 }}>
            <FormLabel>Padrinho:</FormLabel>
            <RadioGroup row value={filtroPadrinho} onChange={e => setFiltroPadrinho(e.target.value)}>
              <FormControlLabel value="Todos" control={<Radio />} label="Todos" />
              <FormControlLabel value="Sim" control={<Radio />} label="Sim" />
              <FormControlLabel value="Não" control={<Radio />} label="Não" />
            </RadioGroup>
          </Box>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1 }}>
            <FormLabel>Confirmado:</FormLabel>
            <RadioGroup row value={filtroConfirmado} onChange={e => setFiltroConfirmado(e.target.value)}>
              <FormControlLabel value="Todos" control={<Radio />} label="Todos" />
              <FormControlLabel value="Sim" control={<Radio />} label="Sim" />
              <FormControlLabel value="Não" control={<Radio />} label="Não" />
            </RadioGroup>
          </Box>
        </Box>
      </Paper>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1.5 }}>
        <Button variant="outlined" onClick={() => fetchConvidados()}>Atualizar lista</Button>
      </Box>
      {isMobile ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {convidadosFiltrados.map((c) => (
            <Paper key={c.id} sx={{ p: 2, bgcolor: c.presente ? 'rgba(76, 175, 80, 0.16)' : 'inherit' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography fontWeight={600}>{c.nome}</Typography>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <FormControlLabel control={<Checkbox checked={!!c.confirmado} onChange={() => handleToggleConfirmado(c)} />} label="Conf." sx={{ m: 0 }} />
                  <FormControlLabel control={<Checkbox checked={!!c.presente} onChange={() => handleTogglePresente(c)} />} label="Pres." sx={{ m: 0 }} />
                </Box>
              </Box>
              <Typography variant="body2">Padrinho: {c.padrinho ? 'Sim' : 'Não'}</Typography>
              <Typography variant="body2">Noivo: {c.noivo}</Typography>
              {isAdmin && (
                <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap' }}>
                  <Button size="small" onClick={() => handleEdit(c)}>Editar</Button>
                  <Button size="small" color="error" onClick={() => handleDelete(c.id)}>Excluir</Button>
                </Box>
              )}
            </Paper>
          ))}
        </Box>
      ) : (
        <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell>Nome</TableCell>
                <TableCell>Padrinho?</TableCell>
                <TableCell>Noivo</TableCell>
                <TableCell>Confirmado?</TableCell>
                <TableCell>Presente?</TableCell>
                {isAdmin && <TableCell>Ações</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {convidadosFiltrados.map((c) => (
                <TableRow key={c.id} sx={{ bgcolor: c.presente ? 'rgba(76, 175, 80, 0.16)' : 'inherit' }}>
                  <TableCell>{c.nome}</TableCell>
                  <TableCell>{c.padrinho ? 'Sim' : 'Não'}</TableCell>
                  <TableCell>{c.noivo}</TableCell>
                  <TableCell>
                    <Checkbox checked={!!c.confirmado} onChange={() => handleToggleConfirmado(c)} disabled={!isAdmin} />
                  </TableCell>
                  <TableCell>
                    <Checkbox checked={!!c.presente} onChange={() => handleTogglePresente(c)} />
                  </TableCell>
                  {isAdmin && (
                    <TableCell>
                      <Button size="small" onClick={() => handleEdit(c)}>Editar</Button>
                      <Button size="small" color="error" onClick={() => handleDelete(c.id)}>Excluir</Button>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}

export default Convidados;
